import { cn, memoClassNames } from '@/utils';
import { QuizPlayerScreenType } from '../types';

const classes = memoClassNames('QuizPlayerScreen', ['root']);

export const QuizPlayerScreen = ({
  className,
  variant,
  ...others
}: React.ComponentProps<'div'> & { variant: QuizPlayerScreenType }) => {
  return (
    <div
      {...others}
      className={cn(classes.root, className)}
      data-variant={variant}
    />
  );
};
